module.exports = __webpack_public_path__ + "img/3516194.jpg";